<div class="modal-header border-0 pb-0">
  <h5 class="modal-title fw-bold datos-geograficos-cemento-modal-title">{{ modalTitle }}</h5>
  <button type="button" class="btn-close" aria-label="Cerrar" (click)="onClose()"></button>
</div>

<form [formGroup]="form" (ngSubmit)="onSave()">
  <div class="modal-body pt-2 pb-1 datos-geograficos-cemento-modal-body">
    <p class="datos-geograficos-cemento-modal-leyenda small text-muted mb-2">* Campos obligatorios</p>
    <div class="row g-3">
      <div class="col-md-6 col-lg-4">
        <label class="form-label fw-semibold text-uppercase small mb-1" for="dg-codigo-region">Código región *</label>
        <input id="dg-codigo-region" type="text" class="form-control" formControlName="codigoRegion" />
        <div class="text-danger small mt-1" *ngIf="fieldError('codigoRegion')">{{ fieldError('codigoRegion') }}</div>
      </div>
      <div class="col-md-6 col-lg-4">
        <label class="form-label fw-semibold text-uppercase small mb-1" for="dg-nombre-region">Nombre región *</label>
        <input id="dg-nombre-region" type="text" class="form-control" formControlName="nombreRegion" />
        <div class="text-danger small mt-1" *ngIf="fieldError('nombreRegion')">{{ fieldError('nombreRegion') }}</div>
      </div>
      <div class="col-md-6 col-lg-4">
        <label class="form-label fw-semibold text-uppercase small mb-1" for="dg-cod-sap-provincia">Cod. SAP provincia *</label>
        <input id="dg-cod-sap-provincia" type="text" class="form-control" formControlName="codSapProvincia" />
        <div class="text-danger small mt-1" *ngIf="fieldError('codSapProvincia')">{{ fieldError('codSapProvincia') }}</div>
      </div>
      <div class="col-md-6 col-lg-4">
        <label class="form-label fw-semibold text-uppercase small mb-1" for="dg-nombre-provincia">Nombre provincia *</label>
        <input id="dg-nombre-provincia" type="text" class="form-control" formControlName="nombreProvincia" />
        <div class="text-danger small mt-1" *ngIf="fieldError('nombreProvincia')">{{ fieldError('nombreProvincia') }}</div>
      </div>
      <div class="col-md-6 col-lg-4">
        <label class="form-label fw-semibold text-uppercase small mb-1" for="dg-cod-sap-comuna">Cod. SAP comuna *</label>
        <input id="dg-cod-sap-comuna" type="text" class="form-control" formControlName="codSapComuna" />
        <div class="text-danger small mt-1" *ngIf="fieldError('codSapComuna')">{{ fieldError('codSapComuna') }}</div>
      </div>
      <div class="col-md-6 col-lg-4">
        <label class="form-label fw-semibold text-uppercase small mb-1" for="dg-nombre-comuna">Nombre comuna *</label>
        <input id="dg-nombre-comuna" type="text" class="form-control" formControlName="nombreComuna" />
        <div class="text-danger small mt-1" *ngIf="fieldError('nombreComuna')">{{ fieldError('nombreComuna') }}</div>
      </div>
      <div class="col-md-6 col-lg-4">
        <label class="form-label fw-semibold text-uppercase small mb-1" for="dg-zona-transporte">Zona transporte *</label>
        <input id="dg-zona-transporte" type="text" class="form-control" formControlName="zonaTransporte" />
        <div class="text-danger small mt-1" *ngIf="fieldError('zonaTransporte')">{{ fieldError('zonaTransporte') }}</div>
      </div>
      <div class="col-md-6 col-lg-4">
        <label class="form-label fw-semibold text-uppercase small mb-1" for="dg-activo">Activo *</label>
        <select id="dg-activo" class="form-select" formControlName="activo">
          <option [ngValue]="true">Sí</option>
          <option [ngValue]="false">No</option>
        </select>
        <div class="text-danger small mt-1" *ngIf="fieldError('activo')">{{ fieldError('activo') }}</div>
      </div>
    </div>
  </div>
  <div class="modal-footer border-0 pt-2 d-flex justify-content-end gap-2">
    <button
      *ngIf="isEditMode"
      type="button"
      class="btn btn-outline-danger"
      [disabled]="loading"
      (click)="onDelete()"
    >
      Eliminar
    </button>
    <button type="submit" class="btn btn-success" [disabled]="loading">
      {{ isEditMode ? 'Guardar' : 'Crear' }}
    </button>
  </div>
</form>
